import { globalStyles } from "@client/shared/constants";
const { display, flex, text } = globalStyles;

const dialogStyles = {
  dialogContent: {
    width: "370px",
    padding: 4,
    ...display.flex,
    flexDirection: "column",
    ...flex.justify.center,
    ...flex.align.center,
    borderBottom: "1px solid",
    borderColor: "grey.300",
  },
  dialogTitle: {
    ...text.align.right,
    padding: "6px",
  },
  heading: {
    fontWeight: "bold",
    marginTop: "8px",
    marginBottom: "8px",
  },
  actions: {
    padding: 2,
    ...flex.justify.center,
  },
  infoBtn: {
    marginTop: "14px",
    width: "120px",
    height: "140px",
  },
  actionButtons: {
    width: "140px",
    padding: "6px",
  },
};

export default dialogStyles;
